<app-login (crossIcon)="receiveCrossIcon($event)" [sendEmail]="sendEmail"
     [formFields]="formFields" [signUpFormFields]="signUpFormFields" [loginDetails]="loginDetails"
    (formData)="receiveData($event)" [forgotPasswordData]="forgotPasswordData"></app-login>

 